import React from "react";

const TransitHotels = () => {
  return (
    <div>
      <div className="container mx-auto pt-24 md:pt-36 pb-12 px-5 text-black">
        <div className="flex flex-col">
          <div className="flex flex-col md:flex-row gap-y-3 items-start">
            <div className="flex items-center text-4xl font-bold head gap-3 md:w-[30%]">
              <span className="text-pry">TRANSIT HOTELS</span>
              <div className="h-2 w-4 bg-black"></div>
            </div>
            <div className="md:w-[60%]">
              Cross Country Transit Hotel is much more than a tastefully
              decorated modern hotel. The hotel’s vibrant and dynamic atmosphere
              has attracted both local and international guests with a passion
              for good rest, food and drink. <br />
              <br /> Whether your business or traveling schedule is packed
              tight, Cross Country Hotel is the perfect place, conveniently
              located within Cross Country Limited corporate office at 345
              Murtala Mohammed Way, Yaba, Lagos <br />
              <br /> If you are planning a home away from home you can leave it
              to us to create the ideal environment with professional staff in
              one of our exquisite room. <br />
              <br /> In our restaurant, we indulge our guests with authentic
              dishes and delicacies made from excellent seasonal ingredients,
              lovingly created by our talented chef. <br />
              <br />
              Hotel Features <br />
              <ul className="list-disc px-4">
                <li>24-hour reception </li>
                <li>Any time Check in </li>
                <li>Latest check out by 12.00</li>
                <li> Canteen and Bar</li>
                <li> Comfortable beds</li>
                <li>Allergy friendly rooms</li>
                <li>Air condition rooms</li>
                <li>Wake-up call </li>
                <li>Car hire </li>
                <li>Laundry and dry cleaning </li>
                <li>Own parking space </li>
                <li>Satellite connected TV </li>
                <li>24 Hours room service </li>
                <li>Adequate safety/security</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TransitHotels;
